import { Label } from '@/components/ui/label';

interface OptionThirdImageFieldProps {
  thirdImageEn: string;
}

export function OptionThirdImageField({ thirdImageEn }: OptionThirdImageFieldProps) {
  return (
    <div className="flex flex-col gap-2">
      <Label>Secondary Image (Top Right Corner)</Label>

      {/* Preview */}
      {thirdImageEn && (
        <div className="relative w-20 h-20 mb-2 border rounded-md overflow-hidden bg-gray-50">
          <img
            src={thirdImageEn}
            alt="Secondary image preview"
            className="w-full h-full object-contain"
            onError={e => {
              e.currentTarget.src = '/no-jersey.png';
            }}
          />
        </div>
      )}
    </div>
  );
}
